import Container from '@/components/Container';
import ProfileInfo from './info/Info';
import { Suspense } from 'react';
import SubContainer from '@/components/Container/SubContainer';
import { useRoot } from './hooks/useRoot';
import { LoadingContainer } from '../mission/shared/components/loading-container';
import { ProfileStreak } from './Streak';
import { ProfilePassword } from './password/Password';
import PageHeader from '@/components/PageHeader';
import { Calendar } from '../calendar/components/calendar';

function ProfileComponent() {
  useRoot();

  return (
    <Container addMargin>
      <SubContainer>
        <PageHeader title={'Your profile'} type="none" />
        <ProfileInfo />
        <ProfileStreak />
        <Calendar />
        <ProfilePassword />
      </SubContainer>
    </Container>
  );
}

export default function ProfilePage() {
  return (
    <Suspense fallback={<LoadingContainer title="Loading profile..." />}>
      <ProfileComponent />
    </Suspense>
  );
}
